import _objectSpread from "E:\\xinyongban\\xinyidai-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\xinyongban\\xinyidai-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { authMangList, authMangDetail, authMangExport, authMangExportData, authUpload, selectQueryNumList // authClose
} from "../../api/authmanget";
import baseUrl from "@/api/baseUrl";
import TopMessage from "@/components/TopMessage";
export default {
  components: {
    TopMessage: TopMessage
  },
  data: function data() {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      dialogUpload: false,
      searchForm: {
        enterpriseCode: "",
        licenseCode: "",
        auditStatus: "",
        page: 1,
        pageSize: 10
      },
      selectedItems: [],
      //选中的项目
      modeUploadForm: {// enterpriseName: "",
        // enterpriseCode: "",
        // licenseList: "",
        // licenseCode: "",
        // licenseSource: "",
        // platformId: "",
        // licenseNum: "",
        // loanPeriod: "",
        // licenseType: "",
        // caSupplier: "",
        // validateUrl: "",
        // file: "",
        // licenseTime: ""
      },
      cuntTotal: 0,
      statusOption: [{
        label: "待审核",
        value: "0"
      }, {
        label: "已同意",
        value: "1"
      }, {
        label: "已拒绝",
        value: "2"
      }, {
        label: "已撤销",
        value: "3"
      }, {
        label: "已上传",
        value: "4"
      }],
      showInfo: {
        fzcnsh: 0,
        //非正常纳税户剩余查询次数    
        acapSvcpre: 0,
        //法人用电信息剩余查询次数
        frbdcdj: 0,
        //企业名下不动产剩余查询次数
        qsxx: 0,
        //欠税信息剩余查询次数
        zzsnssb: 0,
        //增值税缴税信息剩余查询次数
        frfcdy: 0,
        //企业名下不动产抵押剩余查询次数
        qysds: 0,
        //企业所得税缴税剩余查询次数
        sbfqs: 0,
        //社保费欠费信息剩余查询次数
        legalArrears: 0 //法人用电欠费信息剩余查询次数

      },
      tableData: [],
      detailValue: {},
      rules: {
        // licenseList: [
        //   { required: true, message: "请输入", trigger: "blur" }
        // ],
        // licenseCode: [
        //   { required: true, message: "请输入", trigger: "blur" }
        // ],
        // licenseSource: [{ required: true, message: "请选择", trigger: "change" }],
        // loanPeriod: [{ required: true, message: "请选择", trigger: "change" }],
        // licenseType: [
        //   { required: true, message: "请选择", trigger: "change" }
        // ],
        caSupplier: [],
        validateUrl: []
      }
    };
  },
  mounted: function mounted() {
    this.authMangListApi();
  },
  computed: {
    getSourceType: function getSourceType() {
      return this.$store.getters.sourceType;
    },
    organization: function organization() {
      return this.$store.getters.organization ? this.$store.getters.organization : "";
    }
  },
  methods: {
    // 当下拉框值改变时，清除之前的验证结果
    handleFileTypeChange: function handleFileTypeChange(value) {
      var _this = this;

      if (value === "2") {
        // 设置默认值，但允许用户修改
        this.modeUploadForm.caSupplier = "敏行信息技术有限公司";
        this.modeUploadForm.validateUrl = "http://121.236.214.139:8098/ses/fileVerify"; // 2. 动态添加必填规则

        this.rules.caSupplier = [{
          required: true,
          message: "电子签章供应商不能为空",
          trigger: ["blur", "change"]
        }];
        this.rules.validateUrl = [{
          required: true,
          message: "验证地址不能为空",
          trigger: ["blur", "change"]
        }];
      } else {
        this.rules.caSupplier = [];
        this.rules.validateUrl = [];
        this.modeUploadForm.caSupplier = "";
        this.modeUploadForm.validateUrl = "";
      }

      this.$refs.formRef.clearValidate("caSupplier");
      this.$refs.formRef.clearValidate("validateUrl"); // 4. 手动触发表单验证

      this.$nextTick(function () {
        _this.$refs.formRef.validateField("caSupplier");

        _this.$refs.formRef.validateField("validateUrl");
      });
    },
    // 授权企业书导出
    exportAuthBook: function () {
      var _exportAuthBook = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(searchForm) {
        var _ref, filename, blobData, contentType, blob, downloadUrl, link;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return authMangExport(searchForm);

              case 3:
                _ref = _context.sent;
                filename = _ref.filename;
                blobData = _ref.blobData;
                contentType = _ref.contentType;
                blob = new Blob([blobData], {
                  type: contentType
                });
                downloadUrl = window.URL.createObjectURL(blob);
                link = document.createElement("a");
                link.href = downloadUrl; // 设置下载文件名（可以从响应头获取，也可以固定）

                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); // 释放URL对象

                window.URL.revokeObjectURL(downloadUrl);
                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](0);
                this.$message.error("导出失败，请重试");

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 18]]);
      }));

      function exportAuthBook(_x) {
        return _exportAuthBook.apply(this, arguments);
      }

      return exportAuthBook;
    }(),
    // 授权数据导出
    exportData: function () {
      var _exportData = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(searchForm) {
        var _ref2, filename, blobData, contentType, blob, downloadUrl, link;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return authMangExportData(searchForm);

              case 3:
                _ref2 = _context2.sent;
                filename = _ref2.filename;
                blobData = _ref2.blobData;
                contentType = _ref2.contentType;
                blob = new Blob([blobData], {
                  type: contentType
                });
                downloadUrl = window.URL.createObjectURL(blob);
                link = document.createElement("a");
                link.href = downloadUrl; // 设置下载文件名（可以从响应头获取，也可以固定）

                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); // 释放URL对象

                window.URL.revokeObjectURL(downloadUrl);
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](0);
                this.$message.error("导出失败，请重试");

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 18]]);
      }));

      function exportData(_x2) {
        return _exportData.apply(this, arguments);
      }

      return exportData;
    }(),
    // 搜索
    onSubmit: function onSubmit() {
      this.authMangListApi();
    },
    // 列表接口数据
    authMangListApi: function () {
      var _authMangListApi = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return authMangList(_objectSpread({}, this.searchForm, {
                  organization: this.organization
                }));

              case 2:
                res = _context3.sent;
                this.tableData = res.data.data.list;
                this.cuntTotal = res.data.data.total;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function authMangListApi() {
        return _authMangListApi.apply(this, arguments);
      }

      return authMangListApi;
    }(),
    selectable: function selectable(row, index) {
      return row.auditStatus === "1";
    },
    // 多选
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectedItems = val;
    },
    // 批量上传
    batchUpload: function batchUpload() {
      var _this2 = this;

      if (this.selectedItems.length === 0) {
        this.$message.warning("请至少选择一条数据");
        return;
      } // 再次确认所有选中项都是"已同意"状态


      var hasInvalidItems = this.selectedItems.some(function (item) {
        return item.auditStatus !== "1";
      });

      if (hasInvalidItems) {
        this.$message.warning('只能选择审核状态为"已同意"的数据');
        return;
      }

      this.$confirm("\u786E\u5B9A\u8981\u4E0A\u4F20\u9009\u4E2D\u7684 ".concat(this.selectedItems.length, " \u6761\u6570\u636E\u5417?"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return authUpload(_this2.selectedItems);

              case 2:
                res = _context4.sent;
                console.log(res, "this.selectedItems"); // this.uploadItems(this.selectedItems)

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));
    },
    // 确定提交上传接口方法
    submitUpload: function () {
      var _submitUpload = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5() {
        var valid, modeUploadForm, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.$refs.formRef.validate();

              case 3:
                valid = _context5.sent;

                if (valid) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return");

              case 6:
                modeUploadForm = _objectSpread({}, this.modeUploadForm, {
                  startTime: this.modeUploadForm.licenseTime[0],
                  endTime: this.modeUploadForm.licenseTime[1]
                });
                delete modeUploadForm.licenseTime;
                _context5.next = 10;
                return authUpload([modeUploadForm]);

              case 10:
                res = _context5.sent;
                console.log(res, "res"); // if (res.data.code == 200) {
                //   this.$message.success("文档提交成功");
                // }

                _context5.next = 17;
                break;

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](0);
                console.error("提交失败:", _context5.t0); // this.$message.error(error.res?.data?.message || "文档提交失败");

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 14]]);
      }));

      function submitUpload() {
        return _submitUpload.apply(this, arguments);
      }

      return submitUpload;
    }(),
    handleCloseDialog: function handleCloseDialog() {
      // 弹窗关闭表单重置
      this.$refs.formRef.resetFields();
      this.modeUploadForm = {
        enterpriseName: "",
        enterpriseCode: "",
        licenseList: "",
        licenseCode: "",
        licenseSource: "",
        platformId: "",
        licenseNum: "",
        loanPeriod: "",
        licenseType: "",
        caSupplier: "",
        validateUrl: "",
        licenseTime: ""
      }; // this.file = [];
    },
    // 协议上传
    agreeUpload: function agreeUpload(row) {
      if (row.auditStatus !== "1") {
        this.$message.warning('只有审核状态为"已同意"的数据才能上传');
        return;
      }

      this.modeUploadForm = _objectSpread({}, row, {
        enterpriseName: row.enterpriseName,
        enterpriseCode: row.enterpriseCode,
        //统一社会信用代码
        licenseList: row.licenseList,
        //授权信息查询列表
        licenseCode: row.licenseCode,
        //被授权单位统一社会信息代码列表
        licenseSource: row.licenseSource,
        //授权来源
        platformId: row.platformId,
        //地方平台编码
        licenseNum: row.licenseNum,
        //授权查询次数
        loanPeriod: row.loanPeriod,
        //贷款阶段
        licenseType: row.licenseType,
        //授权协议类型
        caSupplier: row.caSupplier,
        //电子签章供应商
        validateUrl: row.validateUrl,
        //验证地址
        licenseTime: [row.startTime, row.endTime],
        //授权起止时间
        attachment: row.attachment //附件信息

      });
      this.dialogUpload = true;
    },
    // 协议撤销
    agreeRevoke: function () {
      var _agreeRevoke = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6(row) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log(row); // const res = await authClose();

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function agreeRevoke(_x3) {
        return _agreeRevoke.apply(this, arguments);
      }

      return agreeRevoke;
    }(),
    // 详情接口
    authMangDetailApi: function () {
      var _authMangDetailApi = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee7(id) {
        var res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return authMangDetail({
                  id: id
                });

              case 2:
                res = _context7.sent;
                this.detailValue = res.data.data;
                console.log(res, "详情");

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function authMangDetailApi(_x4) {
        return _authMangDetailApi.apply(this, arguments);
      }

      return authMangDetailApi;
    }(),
    // 详情
    detailLook: function detailLook(row) {
      this.dialogVisible = true;
      this.authMangDetailApi(row.id);
    },
    countDetail: function countDetail(row) {
      var _this3 = this;

      //接口
      var params = {
        id: row.licenseId,
        organization: this.organization
      };
      selectQueryNumList(params).then(function (res) {
        if (res.data.data != null) {
          var _res$data$data = res.data.data,
              fzcnsh = _res$data$data.fzcnsh,
              acapSvcpre = _res$data$data.acapSvcpre,
              frbdcdj = _res$data$data.frbdcdj,
              qsxx = _res$data$data.qsxx,
              zzsnssb = _res$data$data.zzsnssb,
              frfcdy = _res$data$data.frfcdy,
              qysds = _res$data$data.qysds,
              sbfqs = _res$data$data.sbfqs,
              legalArrears = _res$data$data.legalArrears;
          _this3.showInfo = {
            fzcnsh: fzcnsh,
            //非正常纳税户剩余查询次数    
            acapSvcpre: acapSvcpre,
            //法人用电信息剩余查询次数
            frbdcdj: frbdcdj,
            //企业名下不动产剩余查询次数
            qsxx: qsxx,
            //欠税信息剩余查询次数
            zzsnssb: zzsnssb,
            //增值税缴税信息剩余查询次数
            frfcdy: frfcdy,
            //企业名下不动产抵押剩余查询次数
            qysds: qysds,
            //企业所得税缴税剩余查询次数
            sbfqs: sbfqs,
            //社保费欠费信息剩余查询次数
            legalArrears: legalArrears //法人用电欠费信息剩余查询次数

          };
        }

        _this3.dialogVisible2 = true;
      });
    },
    // 详情附件下载
    downPdf: function downPdf() {
      // 编码转译
      var filname = this.detailValue.attachment;
      var encodedPath = encodeURIComponent(filname);
      var xhr = new XMLHttpRequest();
      xhr.open("get", this.baseUrl + "/api/v1/bankLicense/downloadFile?fileName=".concat(encodedPath), true); // get、post都可

      xhr.responseType = "blob"; // 转换流

      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对

      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response;
          var fileName = filname;

          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var a = document.createElement("a");
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };

      xhr.send();
    },
    detailCloseDialog: function detailCloseDialog() {
      this.dialogVisible = false;
    },
    countDetailCloseDialog: function countDetailCloseDialog() {
      this.dialogVisible2 = false;
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.authMangListApi(this.searchForm);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
      this.authMangListApi(this.searchForm);
    }
  }
};